import styled from 'styled-components';

export const TableMappingWrapper = styled.div`
  margin-top: 40px;
  margin-bottom: 24px;
  width: 475px;
`;

export const Header = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
`;

export const SubHeader = styled.div`
  font-size: 13px;
  line-height: 18px;
  color: #6c757d;
`;
